/**
 * Dosimetry workflow constants — step IDs, feature IDs, and declarative visibility rules.
 *
 * Using typed constants instead of raw strings ensures that step and feature ID
 * references break at compile time if they are renamed, rather than silently diverging.
 */

// ============================================================================
// Step IDs
// ============================================================================

export const DOSIMETRY_STEP = {
    SEGMENTATION: 'segmentation',
    DOSIMETRY: 'dosimetry',
    REPORT: 'report',
} as const;

export type DosimetryStepId = (typeof DOSIMETRY_STEP)[keyof typeof DOSIMETRY_STEP];

// ============================================================================
// Feature IDs
// ============================================================================

export const DOSIMETRY_FEATURE_ID = {
    SEGMENTS: 'ai-dosimetry-segments',
    TUMORS: 'ai-dosimetry-tumors',
    TEP_OVERLAY: 'ai-dosimetry-tep-overlay',
    CURRENT_LOCATION: 'ai-dosimetry-current-location',
} as const;
